var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lucide:download"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5 10.3333V12.7778C14.5 13.1019 14.3712 13.4128 14.142 13.642C13.9128 13.8712 13.6019 14 13.2778 14H4.72222C4.39807 14 4.08719 13.8712 3.85798 13.642C3.62877 13.4128 3.5 13.1019 3.5 12.7778V10.3333M5.94444 7.27778L9 10.3333M9 10.3333L12.0556 7.27778M9 10.3333V3",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.98c1bed1068069b33486bb66609aa20c.svg";
export { ForwardRef as ReactComponent };